import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 80px;

  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    margin-bottom: 20px;
  }

  h4 {
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: ${props => props.theme.font.size['4xl']}px;
  }
`;
